import { render, staticRenderFns } from "./CreditLetterExtract.vue?vue&type=template&id=3fd6860b&scoped=true&"
import script from "./CreditLetterExtract.vue?vue&type=script&lang=js&"
export * from "./CreditLetterExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd6860b",
  null
  
)

export default component.exports